<template>
    <div class="block-main-div">
        <div class="avatar">
            {{
                contactStore.selectedContact?.name
                    .split(' ')
                    .slice(0, 2)
                    .map((word) => word.charAt(0))
                    .join('')
                    .toUpperCase()
            }}
        </div>
        <span>{{ contactStore.selectedContact?.name }}</span>
    </div>
</template>
<script setup lang="ts">
import { useContactsTempStore } from '~/stores/person/contacts-temp';

const contactStore = useContactsTempStore();
</script>
<style lang="scss" scoped>
.block-main-div {
    @apply flex items-center gap-[8px] pl-[80px] self-stretch;

    span {
        @apply text-[#181d27] font-[Inter] text-[14px] font-semibold leading-[20px];
    }
}

.avatar {
    @apply flex justify-center items-center w-[40px] h-[40px] shrink-0 rounded-full border border-[#006df5] bg-[rgba(0,109,245,0.08)] text-[#006df5] text-center font-[Inter] text-[14px] font-semibold leading-[14px];
}
</style>
